import React from 'react';
import MenuItem from './menuitem.js';

class MenuContainer extends React.Component {
	constructor(props) {
		super(props);

		this.onClick = this.onClick.bind(this);
	}

	onClick(e) {
		//If we have onClick, send it up the chain! Control is Buoyant! 
		if(this.props.onClick) this.props.onClick(e);
	}

	render() {

		var itemsArr = [];

		for(var dKey in this.props.items) {
			const item = this.props.items[dKey];

			if(this.props.items.length > 5) {
				item.icon = false;
			}
			else {
				item.label = false;
			}

			var itemJSX = (
				<MenuItem key={dKey + 'MenuItem'} icon={item.icon} label={item.label} dataID={item.dataID} onClick={this.onClick} />
			);

			itemsArr.push(itemJSX);
		}

		const showClass = (this.props.show) ? 'visible' : 'hidden';
		return (
			<div className={'MenuContainer ' + showClass}>
				{itemsArr}
			</div>
		);
	}
}

export default MenuContainer;